export const localLenderDetailsList = {
  102: { tenures: '3, 6, 9 & 12 months EMI Plans' },
  201: { tenures: '3, 6, 9 & 12 months EMI Plans' },
  401: { tenures: '3, 6, 9 & 12 months EMI Plans' },
  501: { tenures: '3, 6, 9, 12, 18 & 24 months EMI Plans' },
  502: { tenures: '15, 30, 60 & 90 days EMI Plans' },
  701: { tenures: '3, 6, 9 & 12 months EMI Plans' },
  901: { tenures: '9, 12, 15 & 18 months EMI Plans' },
};



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/overlayEmiDetails/lendersCard/localLenderDetails.js